import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import { connect } from 'react-redux';
import ItinerarySearchResults from './itineraries/ItinerarySearchResults';
import ItinerarySearch from './search/ItinerarySearch';
import SeatSelection from './seats/SeatSelection';
import SelectedSeats from './seats/SelectedSeats';
import Loader from '../../common/Loader';
import SeatReleasePermissions from './seats/SeatReleasePermissions';
import { searchForItineraries } from '../../../actions';

const RoundTrip = ({ postingReservation, dispatchSearchForItineraries }) => {
  if (postingReservation) return <Loader />;
  return (
    <div>
      <ItinerarySearch />
      <Row>
        <Col lg={6} md={12}>
          <ItinerarySearchResults />
        </Col>
        <Col lg={4} md={6}>
          <SeatSelection />
        </Col>
        <Col lg={2} md={6}>
          <SelectedSeats />
          <SeatReleasePermissions
            formName="BookingItinerarySearchForm"
            dispatchGetItineraries={dispatchSearchForItineraries}
          />
        </Col>
      </Row>
    </div>
  );
};

RoundTrip.propTypes = {
  postingReservation: PropTypes.bool.isRequired,
  dispatchSearchForItineraries: PropTypes.func.isRequired,
};

const mapStateToProps = ({ BookingUnit }) => ({
  postingReservation: BookingUnit.Booking.getIn([
    'passengers',
    'postingReservation',
  ]),
});

const mapDispatchToProps = {
  dispatchSearchForItineraries: searchForItineraries,
};

export default connect(mapStateToProps, mapDispatchToProps)(RoundTrip);
